import { useEffect, useState } from 'react';
import {
    createOrGetIntersectionContext,
    useIntersectionTarget,
} from '../../hooks/useIntersectionObserver';
import { Body1 } from '../../theme';
import { useJobList } from './hooks/useJobList';
import { JobCardLoader } from './JobCard';
import { JobCardList } from './JobCardList';
import styled from 'styled-components6';

export const JOB_LIST_INTERSECTION_OBSERVER_NAME =
    'job-list-intersection-observer';

// approximates 5 job cards below the fold
export const JOB_LIST_INTERSECTION_MARGIN = `0px 0px ${210 * 5}px 0px`;

export const {
    context: JobListIntersectionContext,
    Provider: JobListIntersectionProvider,
} = createOrGetIntersectionContext(JOB_LIST_INTERSECTION_OBSERVER_NAME);

const TotalJobs = styled(Body1)`
    margin-bottom: var(--rwl-spacing-lg);
`;

export const JobList = (): JSX.Element => {
    const {
        jobList,
        onJobCardClicked,
        totalJobs,
        hasMoreJobs,
        fetchNextPage,
        isLoading,
    } = useJobList();
    const { targetRef, reset } = useIntersectionTarget(
        JOB_LIST_INTERSECTION_OBSERVER_NAME,
        () => {
            if (hasMoreJobs && fetchNextPage) {
                fetchNextPage();
            }
        },
        () => void 0,
        {
            rootMargin: JOB_LIST_INTERSECTION_MARGIN,
        }
    );

    // If the intersection observer fires before the job list is loaded, we'll
    // need to reset the intersection observer so that it fires again
    const [isInitialLoad, setIsInitialLoad] = useState(false);
    useEffect(() => {
        if (!isInitialLoad && jobList.length > 0) {
            setIsInitialLoad(true);
            reset();
        }
    }, [jobList, isInitialLoad]);
    return (
        <>
            <TotalJobs>{totalJobs} matching jobs</TotalJobs>
            <JobCardList
                jobList={jobList}
                onJobCardClicked={onJobCardClicked}
                ref={targetRef}
            />
            <JobCardLoader
                style={{ marginTop: 'var(--rwl-spacing-lg)' }}
                $visible={isLoading.toString()}
            />
        </>
    );
};
